module.exports = __webpack_public_path__ + "static/media/Badge.d6587d99.svg";